import Head from 'next/head'
import React from 'react'

const siftInit = `
  (function() {
    function getCookie(c_name) {
      if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) c_end = document.cookie.length;
          return unescape(document.cookie.substring(c_start, c_end));
        }
      }
      return "";
    }
  
    var _user_id = '';
    var _session_id = getCookie('th_uid');
  
    var _sift = window._sift = window._sift || [];
    _sift.push(['_setAccount', '6d960fa9ea']);
    _sift.push(['_setUserId', _user_id]);
    _sift.push(['_setSessionId', _session_id]);
    _sift.push(['_trackPageview']);

    function ls() {
      var e = document.createElement('script');
      e.src = 'https://cdn.sift.com/s.js';
      document.body.appendChild(e);
    }
    if (window.attachEvent) {
      window.attachEvent('onload', ls);
    } else {
      window.addEventListener('load', ls, false);
    }
  })();
`

export default () => (
  <Head>
    <script
      key="sift-init"
      dangerouslySetInnerHTML={{ __html: siftInit }}
      type="text/javascript"
    />
  </Head>
)
